module.exports = __webpack_public_path__ + "static/media/6TunasDouro2.b91de8cc.jpg";